var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUparrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "1000px",
    height: "1000px",
    viewBox: "0 0 1000 1000",
    enableBackground: "new 0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B9B9B9",
    d: "M500,7.518c-269.924,0-488.741,218.817-488.741,488.741C11.259,766.184,230.075,985,500,985 S988.74,766.184,988.74,496.259C988.74,226.335,769.924,7.518,500,7.518z M833.884,573.804c-18.99,0-37.979-7.244-52.468-21.733 L574.647,345.301v481.051C574.647,867.58,541.227,901,500,901c-41.227,0-74.647-33.42-74.647-74.647V345.301l-206.77,206.77 c-28.978,28.978-75.958,28.978-104.935,0c-28.977-28.978-28.977-75.958,0-104.935l333.884-333.884 c13.915-13.915,32.789-21.733,52.467-21.733c0.001,0,0,0,0.001,0c19.679,0,38.553,7.817,52.467,21.733l333.884,333.884 c28.978,28.977,28.978,75.958,0,104.935C871.863,566.56,852.873,573.804,833.884,573.804z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUparrow);
export default __webpack_public_path__ + "static/media/icon-uparrow.efb42e5afbc7c2b2950baad696963e5d.svg";
export { ForwardRef as ReactComponent };